var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Trade"},[_c('v-header'),_c('div',{staticClass:"Trade_box"}),_c('v-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }